export const Empty_PathwayState = (pathwayId) => Object.freeze({
    name: 'New',
    pathwayIds: [pathwayId],
    dds: [],
});
export const Empty_PathwayTransition = (pathwayId, originStateId, label) => Object.freeze({
    pathwayIds: [pathwayId],
    sourceId: originStateId,
    dds: [],
    resolutionFunction: {},
    label
});
export const PathwayVariableContext_TransitionTests = 'transitions-tests';
export const PathwayVariableContext_TransitionConsults = 'transitions-consults';
export const PathwayVariableContext_TransitionTreatments = 'transitions-treatments';
export const PathwayVariableContext_TransitionNurse = 'transitions-nurse';
export const PathwayVariableContext_StatePreconditions = 'state-preconditions';
export const PathwayVariableContext_ResolutionFunctions = 'resolution-function-variables';
//# sourceMappingURL=consts.js.map